import { DynamicAssignModalData } from '@components/modals/dynamicAssignModal/DynamicAssignModal';

const useDynamicAssignModalEventHandlers = () => {
    return {
        onClose: (modalData: DynamicAssignModalData) => {
            const { onCanceled } = modalData;

            if (onCanceled) {
                onCanceled();
            }
        },
    };
};

export default useDynamicAssignModalEventHandlers;
